import {
  endPoints,
  getDocEditorServiceEndPoint,
} from "../Services/base-url/api-constants";

/** Music generation → POST .../api/v1/music/generation */
export function getMusicGenerationApiUrl(): string {
  return getDocEditorServiceEndPoint(endPoints.docEditorService.MUSIC_GENERATION);
}

/** Stem separation → POST .../api/v1/music/stem-separation */
export function getStemSeparationApiUrl(): string {
  return getDocEditorServiceEndPoint(
    endPoints.docEditorService.MUSIC_STEM_SEPARATION,
  );
}
